var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65479 4.595V2.975C5.65479 2.715 5.75978 2.47 5.94978 2.285C6.13978 2.1 6.39478 2 6.65978 2H9.33979C9.60479 2 9.86479 2.105 10.0498 2.285C10.2398 2.47 10.3448 2.715 10.3448 2.975V4.595",
    stroke: "#F64444",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64014 4.91504V13.025C3.64014 13.285 3.74514 13.53 3.93514 13.715C4.12514 13.9 4.38014 14 4.64514 14H11.3501C11.6151 14 11.8751 13.895 12.0601 13.715C12.2501 13.53 12.3551 13.285 12.3551 13.025V4.91504",
    stroke: "#F64444",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.91504H14",
    stroke: "#F64444",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00488 7.5752V11.3402",
    stroke: "#F64444",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99512 7.5752V11.3402",
    stroke: "#F64444",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.bc0229bbe22ae975d541aa41a450ed4c.svg";
export { ForwardRef as ReactComponent };